module.exports = __webpack_public_path__ + "fonts/TTFirs-ExtraLight.b74f542e.woff2";